// the cytoscape "cy" instance will be stored here

export default {
  data: {
    cy: null,
    importedJson: null,
    edgeHandler: null,
  },

  // Methods that you need, for e.g fetching data from server etc.

  fetchData() {
    // fetch logic
  }
};
